import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceService } from 'src/app/services/service.service';
import { UtilService } from 'src/app/services/util.service';
import { TakeOrderModel } from './take-order-model';
import { error } from 'console';

@Component({
  selector: 'app-take-order',
  templateUrl: './take-order.component.html',
  styleUrls: ['./take-order.component.css']
})
export class TakeOrderComponent implements OnInit {

  tenants = [];
  selectedTenant = null;
  dealers = [];
  cards = [];
  terminalSuppliersMapping = [];
  selectedDealer = null;
  selectedDealerFromBackend = null;
  takeOrderActive = true;
  allowOrderSelection = false;
  model: NgbDateStruct;
  deliverySlots = [{ name: "AM" }, { name: "PM" }, { name: "MA-AM" },];
  products = [];
  defaultProducts = ["reg", "mid", "prem", "ulsd"];
  //List to store all the products for a tenant
  productList = [];
  newProductAdded = null;
  availableTanks = [];
  selectedMoments = [];
  takeOrderModel: TakeOrderModel = new TakeOrderModel();
  minFrom = undefined;
  maxFrom = undefined;
  minTo = undefined;
  maxTo = undefined;
  selectDeliveryStartTime = false;
  selectDeliveryEndTime = false;
  deliveryTimeStartFormatted = null;
  deliveryTimeEndFormatted = null;
  user = null;

  // get the successModal from the html using angular annotation
  @ViewChild('successModal')
  successModal: any;

  constructor(private service: ServiceService, private utilService: UtilService, private ngModal: NgbModal) { }

  ngOnInit(): void {
    $(".overlay-loading").show();
    // minFrom is last 5 days and maxFrom is next 5 days
    // subtract 5 days from today
    this.resetTimeSelections();

    this.user = JSON.parse(localStorage.getItem("user"));

    

    this.service.getAssociatedBilltypes().subscribe(tenantResponse => {
      $(".overlay-loading").hide();
      tenantResponse.forEach(tenant => {
        if (tenant?.tenantDTO?.allowOrderFromPortal) {
          this.tenants.push(tenant);
        }
      });
      if(this.tenants.length > 0) {
        this.selectedTenant = this.tenants[0];
        this.changeTenantFilter();
      }
    }, error => {
      $(".overlay-loading").hide();
      console.error(error);
    });
  }

  private resetTimeSelections() {
    this.minFrom = new Date();
    this.minFrom.setDate(this.minFrom.getDate() - 5);
    this.maxFrom = new Date();
    this.maxFrom.setDate(this.maxFrom.getDate() + 5);
    // set the delivery start time to current time - 6 hours and set minutes and seconds to 0
    let deliveryTimeStart = new Date();
    deliveryTimeStart.setHours(deliveryTimeStart.getHours() + 4);
    deliveryTimeStart.setMinutes(0);
    deliveryTimeStart.setSeconds(0);
    this.takeOrderModel.deliveryTimeStart = this.utilService.formatDateToSave(deliveryTimeStart);
    this.deliveryTimeStartFormatted = this.utilService.formatDateToDisplay(new Date(this.takeOrderModel.deliveryTimeStart));

    // set the delivery end time to current time + 4 hours and set minutes and seconds to 0
    let deliveryTimeEnd = new Date();
    deliveryTimeEnd.setHours(deliveryTimeEnd.getHours() + 6);
    deliveryTimeEnd.setMinutes(0);
    deliveryTimeEnd.setSeconds(0);
    this.takeOrderModel.deliveryTimeEnd = this.utilService.formatDateToSave(deliveryTimeEnd);
    this.deliveryTimeEndFormatted = this.utilService.formatDateToDisplay(new Date(this.takeOrderModel.deliveryTimeEnd));
  }

  checkTenantFiltersAvailability() {
  }

  displayCount(load) {
    console.log(load);
  }

  changeTenantFilter() {
    $(".overlay-loading").show();
    this.dealers = [];
    this.products = [];
    this.productList = [];
    this.selectedDealer = null;
    this.selectedDealerFromBackend = null;
    this.resetOrderChanges();
    

    this.dealers = this.selectedTenant?.dealers;
    $(".overlay-loading").hide();

    this.service.getProductsForTenant(this.selectedTenant?.tenantDTO?.tenantId).subscribe(products => {
      this.productList = products;
    })
  }

  changeDealerFilter() {

  }

  takeOrder() {

    // show loader
    $(".overlay-loading").show();
    this.products = [];

    console.log("Selected Dealer :: ", this.selectedDealer);
    
    this.service.getDealersForBilltypes(this.selectedTenant?.tenantDTO?.tenantId, this.selectedDealer?.usualBillingType).subscribe(dealersNCards => {
      // this.dealers = dealersNCards?.dealers;
      this.cards = dealersNCards?.tblcards;
      this.terminalSuppliersMapping = dealersNCards?.terminalSuppliersMapping;
    }, error => {
    });


    this.service.findSelectedDealer(this.selectedDealer.locationID, this.selectedDealer.tenant).subscribe(dealer => {
      $(".overlay-loading").hide();
      this.selectedDealerFromBackend = dealer;
      this.allowOrderSelection = true;
      this.service.findDealerAndStationDetails(this.selectedDealer.locationID + ':' + this.selectedDealer.tenant).subscribe(results => {
        this.availableTanks = results["tblTanks"];
        if (this.availableTanks && this.availableTanks.length > 0) {
          this.availableTanks.forEach(tank => {
            for (let productFetched of this.productList) {
              if (tank.productID == productFetched?.productId) {
                let product = this.generateProductModel(productFetched, tank);
                // console.log(this.terminalSuppliersMapping);
                this.selectedDealer.lastTerminal;
                this.selectedDealer.lastPin;
                this.selectedDealer.dieselCard;

                // fetch all the keys for terminalSuppliersMapping
                Object.keys(this.terminalSuppliersMapping)?.forEach(key => {
                  let mapping = this.terminalSuppliersMapping[key];
                  if (mapping?.terminal?.terminalId == this.selectedDealer?.lastTerminal) {
                    product.terminalSupplierMapping = mapping;
                  }
                });

                this.cards?.forEach(card => {
                  if (card.cardid == this.selectedDealer?.lastPin) {
                    let loadUnderId = card?.loadUnder;
                    product?.terminalSupplierMapping?.tblLoadUnders?.forEach(tblLoadUnder => {
                      if (loadUnderId == tblLoadUnder?.loadUnderID) {
                        product.tblLoadUnder = tblLoadUnder;
                      }
                    });
                  }
                });

                product.quantity = product?.quantity ? product?.quantity : undefined;
                this.products.push(product);
              }
            }
          })
        } else {
          this.defaultProducts.forEach(defaultProduct => {
            let productCount = 0;
            for (let productFetched of this.productList) {
              if (productFetched.displayCode) {
                if (productCount == 0 && productFetched.displayCode.toLowerCase().includes(defaultProduct)) {
                  let product = this.generateProductModel(productFetched, null);
                  product.quantity = product?.quantity ? product?.quantity : undefined;
                  this.products.push(product);
                  productCount++;
                }
              }
            }
          });
        }
      });
    }, error => {
      $(".overlay-loading").hide();
    })

    this.service.findDeliverySlots(this.selectedDealer.tenant).subscribe(deliverySlots => {
      // this.deliverySlots = deliverySlots;
    })
  }

  private generateProductModel(productFetched: any, tank: any): any {
    return {
      quantity: 0.0,
      productName: productFetched?.productName,
      class: this.utilService.selectClass(productFetched?.displayCode),
      terminalId: this.selectedDealer?.billtype?.defaultTerminal,
      supplierId: "1",
      tankName: tank?.tankName,
      productId: productFetched?.productId
    };
  }

  removeProduct(product) {
    const index: number = this.products.indexOf(product);
    if (index !== -1) {
      this.products.splice(index, 1);
    }
  }

  addProduct(product?, newProduct?) {
    if (!product) {
      product = {
        quantity: undefined,
        productName: null,
        class: null,
        terminalId: this.selectedDealer?.billtype?.defaultTerminal,
        supplierId: "1",
        tankName: null,
        productId: null,
      };
      this.products = this.products.concat(product);
    } else {
      product.productName = this.newProductAdded.productName;
      product.productId = this.newProductAdded.productId;
      product.class = this.utilService.selectClass(this.newProductAdded?.displayCode)
    }

  }

  captureOrder() {
    let takeOrderModels = [];
    let orderLineCounter = 0;
    this.products.forEach(product => {
      orderLineCounter += 10;
      let copyTakeOrderModel: TakeOrderModel = JSON.parse(JSON.stringify(this.takeOrderModel));
      copyTakeOrderModel.orderLine = orderLineCounter.toString();
      copyTakeOrderModel.productCode = product.displayCode;
      copyTakeOrderModel.productDescription = product.displayCode;
      // copyTakeOrderModel.tankDescription = product.productName;
      copyTakeOrderModel.deliveryTimeStart = this.utilService.formatDateToSave(this.takeOrderModel.deliveryTimeStart);
      copyTakeOrderModel.deliveryTimeEnd = this.utilService.formatDateToSave(this.takeOrderModel.deliveryTimeEnd);
      copyTakeOrderModel.productCode = product?.productId;
      copyTakeOrderModel.terminalID = product?.terminalSupplierMapping?.terminal?.terminalId ? product?.terminalSupplierMapping?.terminal?.terminalId : "1";
      copyTakeOrderModel.terminalName = product?.terminalSupplierMapping?.terminal?.terminalName;
      copyTakeOrderModel.supplierID = product?.tblLoadUnder?.loadUnderID ? product?.tblLoadUnder?.loadUnderID : "1";
      copyTakeOrderModel.supplierName = product?.tblLoadUnder?.loadUnderName;
      copyTakeOrderModel.quantityOrdered = product?.quantity;
      copyTakeOrderModel.tankDescription = null;
      copyTakeOrderModel.tankSize = null;
      copyTakeOrderModel.deliveryDate = this.utilService.formatDateToSave(this.takeOrderModel.deliveryDate);
      copyTakeOrderModel.customerAddrDescription = this.selectedDealer?.dealer;
      copyTakeOrderModel.customerAddrLine1 = this.selectedDealer?.address;
      copyTakeOrderModel.customerAddrCity = this.selectedDealer?.city;
      copyTakeOrderModel.customerAddrState = this.selectedDealer?.state;
      copyTakeOrderModel.customerAddrZip = this.selectedDealer?.zip;
      copyTakeOrderModel.fTPSCAC = this.selectedTenant?.tenantDTO?.scac;
      copyTakeOrderModel.grossGallons = product?.quantity;
      copyTakeOrderModel.customerNo = this.selectedTenant?.billingCode;
      takeOrderModels.push(copyTakeOrderModel);
    });
    $(".overlay-loading").show();
    this.service.takeOrder(takeOrderModels, this.selectedDealer.tenant).subscribe(order => {
      $(".overlay-loading").hide();
      this.resetOrderChanges();
      this.takeOrderActive = true;
      // display a modal that the order has been placed successfully
      this.openModalForDetails(this.successModal)
    }, error => {
      $(".overlay-loading").hide();
      console.error(error);
    });
  }


  public openModalForDetails(content?: any): void {
    this.modalRef = this.ngModal.open(content, {
      size: "lg"
    });

  }

  modalRef: any;


  resetOrderChanges() {
    this.takeOrderModel = new TakeOrderModel();
    this.products = [];
    this.takeOrderActive = true;
    this.allowOrderSelection = false;
    this.selectedDealer = null;
    this.selectedDealerFromBackend = null;
    this.resetTimeSelections();
  }

  selectDeliveryDate() {
    console.log("Delivery start",this.takeOrderModel.deliveryTimeStart);

    this.minTo = new Date(this.utilService.formatDateToSave(this.takeOrderModel.deliveryTimeStart));
    this.minTo.setDate(this.minTo.getDate() + 1);
    this.maxTo = new Date();
    this.maxTo.setDate(this.minTo.getDate() + 5);
    this.takeOrderModel.deliveryDate = this.utilService.formatDateOnly(this.takeOrderModel.deliveryTimeStart);
  }

  trackChanges(event) {
  }

  changeStartTime(event) {
    let formattedDate = this.utilService.formatDateToSave(event);
    // check if the start time is greater than end time then throw validation error
    // if (new Date(formattedDate) > new Date(this.takeOrderModel.deliveryTimeEnd)) {
    //   alert("Start time cannot be greater than end time");
    //   return;
    // }
    this.takeOrderModel.deliveryTimeStart = formattedDate;
    this.selectDeliveryStartTime = false;
    console.log("Event", event);
    this.deliveryTimeStartFormatted = this.utilService.formatDateToDisplay(new Date(this.takeOrderModel.deliveryTimeStart));
    this.selectDeliveryDate();
  }

  changeEndTime(event) {
    let formattedDate = this.utilService.formatDateToSave(event);
    // check if the end time is less than start time then throw validation error
    if (new Date(formattedDate) < new Date(this.takeOrderModel.deliveryTimeStart)) {
      alert("End time cannot be less than start time");
      return;
    }
    this.takeOrderModel.deliveryTimeEnd = formattedDate;
    this.selectDeliveryEndTime = false;
    console.log("Event", event);
    this.deliveryTimeEndFormatted = this.utilService.formatDateToDisplay(new Date(this.takeOrderModel.deliveryTimeEnd));
  }

}
